module.exports = "<div class=\"container-fluid\">\n  <router-outlet></router-outlet>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app.html
 ** module id = 321
 ** module chunks = 2
 **/